// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3EkDA","vLegacy":"SelectSecondary_vLegacy__2OO_c","error":"SelectSecondary_error__1_-du","disabled":"SelectSecondary_disabled__3j6O3"};